/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule, JobDrawDetailsTabBusinessService, JobDetailsDrawsTabComponent } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';
import { BuilderAccountingRoutingModule } from './builder-accounting-routing.module';
import { DrawDetailsJobFormComponent } from './components/draw-details/draw-details-job-form/draw-details-job-form.component';
import { DrawDetailsLendersFormComponent } from './components/draw-details/draw-details-lenders-form/draw-details-lenders-form.component';
import { DrawDetailsLendersIncludedListComponent } from './components/draw-details/draw-details-lenders-included-list/draw-details-lenders-included-list.component';
import { DrawDetailsPaymentFormComponent } from './components/draw-details/draw-details-payment-form/draw-details-payment-form.component';
import { DrawDetailsPaymentProgressFormComponent } from './components/draw-details/draw-details-payment-progress-form/draw-details-payment-progress-form.component';
import { DrawDetailsPaymentVariationListComponent } from './components/draw-details/draw-details-payment-variation-list/draw-details-payment-variation-list.component';
import { DrawDetailsComponent } from './components/draw-details/draw-details.component';
import { XeroIssueLogListComponent } from './components/xero-issue-log-list';
import { XeroSyncComponent } from './components/xero-sync';
import { XeroIssueLogBusinessService, XeroSyncBusinessService } from './resources';
import { DrawDetailsBusinessService } from './resources/draw-details-business.service';
import { DrawListComponent } from './components/draw-list/draw-list.component';
import { DrawListBusinessService } from './resources/draw-list-business.service';
import { DrawDetailsMakeDrawTabComponent } from './components/draw-details/draw-details-make-draw-tab/draw-details-make-draw-tab.component';
import { ViewDrawDetailsComponent } from './components/view-draw-details/view-draw-details.component';

@NgModule({
  entryComponents: [
    DrawDetailsMakeDrawTabComponent,
    JobDetailsDrawsTabComponent,
  ],
  imports: [
    CoreUiExtSplitPaneModule,
    BuilderSharedModule.forChild(),
    BuilderAccountingRoutingModule,
  ],
  providers: [
    DrawDetailsBusinessService,
    XeroIssueLogBusinessService,
    XeroSyncBusinessService,
    DrawListBusinessService,
    JobDrawDetailsTabBusinessService,
  ],
  declarations: [
    DrawDetailsComponent,
    DrawDetailsJobFormComponent,
    DrawDetailsPaymentFormComponent,
    DrawDetailsPaymentVariationListComponent,
    DrawDetailsPaymentProgressFormComponent,
    DrawDetailsLendersFormComponent,
    DrawDetailsLendersIncludedListComponent,
    XeroIssueLogListComponent,
    XeroSyncComponent,
    DrawListComponent,
    DrawDetailsMakeDrawTabComponent,
    ViewDrawDetailsComponent,
  ],
})
export class BuilderAccountingModule {
}
